import { render, staticRenderFns } from "./SubjectMappingRow.vue?vue&type=template&id=792bd2e0&scoped=true&"
import script from "./SubjectMappingRow.vue?vue&type=script&lang=js&"
export * from "./SubjectMappingRow.vue?vue&type=script&lang=js&"
import style0 from "./SubjectMappingRow.vue?vue&type=style&index=0&id=792bd2e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792bd2e0",
  null
  
)

export default component.exports